import clsx from 'clsx';
import MutedText from 'components/common/MutedText';
import HubertInput from 'components/HubertUI/HubertInput';
import HubertLabel from 'components/HubertUI/HubertLabel';
import { useTranslation } from 'react-i18next';
import type { TQuestionPresentation } from '@hubertai/screening-question-types';
import { ECreateQuestionMode, useQuestionEditorContext } from '../context/create-question.context';
import InTemplateInterviewSummaryLabel from './InTemplateInterviewSummaryLabel';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';

import { selectQuestionLanguage, selectQuestionMode, selectQuestionPresentation } from 'rtk/questionEditorSelector';
import { updatePresentation } from 'rtk/Question.Editor.Slice';

const TemplateInterviewSummaryLabel = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const questionLanguage = useAppSelector((state) => selectQuestionLanguage(state, questionId));
  const questionPresentation = useAppSelector((state) => selectQuestionPresentation(state, questionId));
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));

  if (mode === ECreateQuestionMode.InTemplateEdit) {
    return <InTemplateInterviewSummaryLabel />;
  }

  return (
    <div className={clsx('flex flex-col justify-start gap-4', 'p-1')}>
      <div className={clsx('flex flex-row justify-start gap-4', 'hubert-vertical-center')}>
        <HubertLabel className="text-sm font-medium" htmlFor="create-question-presentation-label">
          {t('summaryLabel.label')}
        </HubertLabel>
        <HubertInput
          id="create-question-presentation-label"
          placeholder={t('summaryLabel.placeholder')}
          value={questionPresentation.label[questionLanguage]}
          onChange={(e) => {
            if (e.target.value !== undefined) {
              dispatch(
                updatePresentation({
                  questionId,
                  presentation: {
                    ...questionPresentation,
                    label: {
                      [questionLanguage]: e.target.value,
                    },
                  } as TQuestionPresentation,
                }),
              );
            }
          }}
        />
      </div>
      <div className="">
        <MutedText text={t('summaryLabel.hint')} />
      </div>
    </div>
  );
};

export default TemplateInterviewSummaryLabel;
